/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ModelKeyProvider } from './model-key.provider';

export interface MessageFactory {
  getMessage(source: any): string;
}

export class MessageFactoryProvider {
  private static readonly messageFactories = new Map<string, MessageFactory>();

  static registerMessageFactory(key: string, factory: MessageFactory) {
    MessageFactoryProvider.messageFactories.set(key, factory);
  }

  static resolveMessageFactory(key: string | object): MessageFactory {
    if (typeof key === 'object') {
      const modelKey = ModelKeyProvider.resolveKey(key);
      return modelKey ? MessageFactoryProvider.messageFactories.get(modelKey) : undefined;
    }
    return MessageFactoryProvider.messageFactories.get(key);
  }
}

